import { Statistic } from '../components/StockTable';

// Insider transactions statistics configuration organized by category
// Note: Using 'financial' type for all since Statistic type only allows 'ratio' | 'financial' | 'date'
// Formatting logic is handled in formatStatisticValue based on the statistic key
export const INSIDER_TRANSACTIONS_STATISTICS: Statistic[] = [
  // Past 90 Days Insider Transactions
  { key: 'numberOfBuyers', label: '# of Buyers', type: 'financial' },
  { key: 'numberOfSellers', label: '# of Sellers', type: 'financial' },
  { key: 'buyersMinusSellers', label: 'Buyers - Sellers', type: 'financial' },
  { key: 'numberOfPurchases', label: '# of Purchases', type: 'financial' },
  { key: 'numberOfSales', label: '# of Sales', type: 'financial' },
  { key: 'purchasesMinusSales', label: 'Purchases - Sales', type: 'financial' },
  { key: 'totalSharesPurchased', label: 'Total Shares Purchased', type: 'financial' },
  { key: 'totalSharesSold', label: 'Total Shares Sold', type: 'financial' },
  { key: 'sharesPurchasedMinusSharesSold', label: 'Shares Purchased - Shares Sold', type: 'financial' },
  
  // Recent Transactions
  { key: 'recentTransaction1', label: 'Transaction 1', type: 'financial' },
  { key: 'recentTransaction2', label: 'Transaction 2', type: 'financial' },
  { key: 'recentTransaction3', label: 'Transaction 3', type: 'financial' },
  { key: 'recentTransaction4', label: 'Transaction 4', type: 'financial' },
  { key: 'recentTransaction5', label: 'Transaction 5', type: 'financial' },
  { key: 'recentTransaction6', label: 'Transaction 6', type: 'financial' },
  { key: 'recentTransaction7', label: 'Transaction 7', type: 'financial' },
  { key: 'recentTransaction8', label: 'Transaction 8', type: 'financial' },
  { key: 'recentTransaction9', label: 'Transaction 9', type: 'financial' },
  { key: 'recentTransaction10', label: 'Transaction 10', type: 'financial' },
];

// Category headers for organizing statistics
export const INSIDER_TRANSACTIONS_CATEGORY_HEADERS = [
  { startIndex: 0, label: 'Past 90 Days Insider Transactions' },
  { startIndex: 9, label: 'Recent Transactions' },
];

/** ETFs/ETVs have no insider data; skip insider sync and show zeros / dashes in the UI. */
export function isEtfOrEtvMarketType(marketType: string | null | undefined): boolean {
  if (!marketType) return false;
  const u = marketType.trim().toUpperCase();
  return u === 'ETF' || u === 'ETV';
}

export function createEmptyInsiderTransactionData(
  tickerSymbol: string,
  tickerBasicsId: number,
): {
  tickerSymbol: string;
  tickerBasicsId: number;
  aggregatedData: {
    numberOfBuyers: number;
    numberOfSellers: number;
    buyersMinusSellers: number;
    numberOfPurchases: number;
    numberOfSales: number;
    purchasesMinusSales: number;
    totalSharesPurchased: number;
    totalSharesSold: number;
    sharesPurchasedMinusSharesSold: number;
  };
  detailedData: { recentTransactions: any[] };
} {
  return {
    tickerSymbol,
    tickerBasicsId,
    aggregatedData: {
      numberOfBuyers: 0,
      numberOfSellers: 0,
      buyersMinusSellers: 0,
      numberOfPurchases: 0,
      numberOfSales: 0,
      purchasesMinusSales: 0,
      totalSharesPurchased: 0,
      totalSharesSold: 0,
      sharesPurchasedMinusSharesSold: 0,
    },
    detailedData: { recentTransactions: [] },
  };
}

